import { useEffect, useState } from "react";
import { Table, Typography, Tag, Tooltip, Space } from "antd";
import { ShoppingCartOutlined } from "@ant-design/icons";
import { getLineasActaPO } from "../../../../services/financiero/ingresosPO/entregasPOService";
import styles from "../../ingresosPOStyles.module.css";

const { Text } = Typography;

const formatNumber = (value) => new Intl.NumberFormat("es-CO").format(Number(value || 0));

const clamp = (lineas) => ({ display: "-webkit-box", WebkitLineClamp: lineas, WebkitBoxOrient: "vertical", overflow: "hidden" });

// Alto máximo del listado: a partir de aquí aparece el scroll interno, con el
// encabezado fijo, para que un acta con muchos productos no estire la tabla.
const ALTO_MAXIMO = 300;

export default function EntregaLineasExpand({ record }) {

  const [loading, setLoading] = useState(true);
  const [lineas, setLineas] = useState([]);

  useEffect(() => {
    let activo = true;
    setLoading(true);
    getLineasActaPO({
      oid_participante: record.oid_participante,
      tipo_entrega: record.tipo_entrega,
      fecha_entrega: record.fecha_entrega
    })
      .then((data) => { if (activo) setLineas(data); })
      .catch(() => { if (activo) setLineas([]); })
      .finally(() => { if (activo) setLoading(false); });
    return () => { activo = false; };
  }, [record.oid_participante, record.tipo_entrega, record.fecha_entrega]);

  const totalCantidad = lineas.reduce((acc, l) => acc + Number(l.cantidad || 0), 0);

  const columns = [
    {
      title: "#",
      width: 50,
      align: "center",
      render: (_, __, index) => <Text type="secondary">{index + 1}</Text>
    },
    {
      title: "Producto",
      dataIndex: "nombre_producto",
      width: 280,
      render: (value, row) => <Text strong style={clamp(2)}>{row.nombre_corto || value}</Text>
    },
    {
      title: "Descripción",
      render: (_, row) => {
        const detalle = row.descripcion || row.tipo_producto;
        if (!detalle) return <Text type="secondary">—</Text>;
        return (
          <Tooltip title={detalle} placement="topLeft">
            <Text type="secondary" style={clamp(2)}>{detalle}</Text>
          </Tooltip>
        );
      }
    },
    {
      title: "Cantidad",
      dataIndex: "cantidad",
      width: 110,
      align: "center",
      render: (value) => <Text strong>{formatNumber(value)}</Text>
    },
    { title: "Unidad", dataIndex: "unidad_medida", width: 130 }
  ];

  return (
    <div
      className={styles.lineasActa}
      style={{
        margin: "4px 8px 8px 40px",
        border: "1px solid #e5eaf2",
        borderRadius: 10,
        overflow: "hidden",
        background: "#fff"
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "8px 14px",
          background: "#f5f8ff",
          borderBottom: "1px solid #e5eaf2"
        }}
      >
        <Space size={8}>
          <ShoppingCartOutlined style={{ color: "#042956" }} />
          <Text strong style={{ color: "#042956" }}>Productos entregados</Text>
        </Space>
        {!loading && (
          <Space size={6}>
            <Tag color="blue" style={{ marginRight: 0 }}>{lineas.length} producto{lineas.length === 1 ? "" : "s"}</Tag>
            <Tag style={{ marginRight: 0 }}>{formatNumber(totalCantidad)} unidades</Tag>
          </Space>
        )}
      </div>
      <Table
        rowKey="oid"
        size="small"
        loading={loading}
        columns={columns}
        dataSource={lineas}
        pagination={false}
        scroll={{ y: ALTO_MAXIMO }}
        locale={{ emptyText: "Esta acta no tiene productos" }}
      />
    </div>
  );
}
